<label class="text-muted col-form-label pl-0 font-weight-bold">{{ label }}</label
><br />
<span class="form-control-plaintext form-control">{{ model }}</span>
